import {PricingConfig} from '@flexinet/pricing-components';
import {stage} from './stage.ts';

// flexinet-console-api endpoints — owns the ApplicationProducts link table
// (which products are available to which application).
const platformApi: PricingConfig['platformApi'] = {
    prod: {
        endpoint: 'https://jerup2o5nzej3hnn2sdv3ejtca.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'f2bfbc00-3e46-4327-9998-7ec47fd6e36c',
    },
    test: {
        endpoint: 'https://thz4u5ksajh6blvulnhiiddudi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    },
    dev: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '688679a2-2983-4299-b7e6-ec87fb538c24',
    },
    ide: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '688679a2-2983-4299-b7e6-ec87fb538c24',
    },
};

// flexinet-billing-api endpoints — owns rich Product data (descriptions,
// line items, prices, free-trial badge). pricing-components 0.4.0+
// requires this so it can stitch link-table results with rich Product data
// per FNP-88. Endpoints mirror the canonical billingApiConfig used by
// flexinet-portal-app's billing-api-integration module.
const billingApi: PricingConfig['billingApi'] = {
    prod: {
        endpoint: 'https://awqbc7agkrdxza4di3ggk2tsnq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    test: {
        endpoint: 'https://jwbq5ckinrd2bctdhu47c3jjva.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://43ruvo3zkbf4jkj7zpsisoubmi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://43ruvo3zkbf4jkj7zpsisoubmi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const publicPricingConfig: PricingConfig = {
    stage: stage,
    authMode: 'iam',
    pricingPageTitle: 'Flexi Bot Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
    billingApi,
};

export const authenticatedPricingConfig: PricingConfig = {
    stage: stage,
    authMode: 'userPool',
    pricingPageTitle: 'Flexi Bot Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
    billingApi,
};
